/**
 * Gol de Placa / Gol de Ouro (itens 15-18 da revisão final). O bônus é
 * sempre exclusivo por partida — nunca os dois juntos (item 17).
 */
export type RoundBonusType = "gol_de_placa" | "gol_de_ouro";

export const ROUND_BONUS_MULTIPLIER: Record<RoundBonusType, number> = {
  gol_de_placa: 2,
  gol_de_ouro: 3,
};

export const ROUND_BONUS_LABEL: Record<RoundBonusType, string> = {
  gol_de_placa: "Gol de Placa ×2",
  gol_de_ouro: "Gol de Ouro ×3",
};

export interface RoundBonus {
  matchId: string;
  round: number;
  type: RoundBonusType;
}
